<template>
  <div id="view-linkinfo">
    <h4 class="page_heading">View LinkInfo : </h4>

    <ul class="collection with-header">
      <li class="collection-header">
        <h4>{{link_name}}</h4>
      </li>
      <li class="collection-item">
        <b>Link Id</b>
        : {{link_id}}
      </li>
      <li class="collection-item">
        <b>link_url</b>
        : {{link_url}}
      </li>
      <li class="collection-item">
        <b>link_type</b>
        : {{link_type}}
      </li>

      <li class="collection-item">
        <b>Link Description</b>
        {{link_desc_html}}
        : <span v-html="link_desc_html"></span>
      </li>
      <li class="collection-item">
        <b>Link Category</b>
        : {{link_category}}
      </li>

    </ul>
    <router-link to="/" class="btn grey">Back</router-link>
    <button @click="deleteEmployee" class="btn red">Delete</button>

    <div class="fixed-action-btn">
      <router-link
        :to="{name:'edit-linkinfo',link_id:link_id}"
        class="btn-floating btn-large red"
      >
        <i class="fa fa-pencil"></i>
      </router-link>
    </div>
  </div>
</template>
<script>
import db from "./firebaseInit";

export default {
  name: "view-linkinfo",
  data() {
    return {
      link_id: null,
      link_name: null,
      link_url: null,
      link_type: null,

      link_desc:null,
      link_category:null,
      set: false
    };
  },

  beforeRouteEnter(to, from, next) {
    db.collection("linkinfo")
      .where("link_id", "==", to.params.link_id)
      .get()
      .then(querySnapshot => {
        querySnapshot.empty === true
          ? next({
              path: "/",
              query: {
                redirect: to.fullpath
              }
            })
          : "";
        querySnapshot.forEach(doc => {
          next(vm => {
            (vm.link_id = doc.data().link_id),
              (vm.link_name = doc.data().link_name),
              (vm.link_url = doc.data().link_url),
              (vm.link_type = doc.data().link_type),

              (vm.link_desc = doc.data().link_desc),
              (vm.link_category = doc.data().link_category);                            
          });
        });
      });
  },
  watch: {
    $route: "fetchData"
  },
  methods: {
    fetchData() {
      db.collection("linkinfo")
        .where("link_id", "==", this.$route.params.link_id)
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
              (this.link_id = doc.data().link_id),
              (this.link_name = doc.data().link_name),
              (this.link_url = doc.data().link_url),
              (this.link_type = doc.data().link_type);

              (this.link_desc = doc.data().link_desc);
              (this.link_category = doc.data().link_category);
          });
        });
    },
    deleteEmployee() {
      if (confirm("Are you sure?")) {
        db.collection("linkinfo")
          .where("link_id", "==", this.$route.params.link_id)
          .get()
          .then(querySnapshot => {
            querySnapshot.forEach(doc => {
              doc.ref.delete();
              this.$router.push("/");
            });
          });
      }
    }
},
computed:{

  link_desc_html:function(){
    if(this.link_desc)
    return this.link_desc.replace(/\n/g, '<br />');
  }
}

};
</script>

<style>
</style>




// WEBPACK FOOTER //
// src/components/LinkViewInfo.vue